export enum PaymentOperationTypeEnum {
  WALLET_TOP_UP = 'WALLET_TOP_UP',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SAVE_CARD = 'SAVE_CARD',
  PAY_AS_YOU_GO_CREDIT = 'PAY_AS_YOU_GO_CREDIT',
  PROPOSAL = 'PROPOSAL',
  PACKAGE = 'PACKAGE',
  LISTING_FEATURE = 'FEATURING',
}

export enum PaymentMethodEnum {
  NEW_CARD = 'NEW_CARD',
  SAVED_CARD = 'SAVED_CARD',
  WALLET = 'WALLET',
  CASH = 'CASH',
}
